
import documentCard from '@/components/detail/document.vue';

export default {
  components: {
    documentCard
  },
  props: {
    tenderId: {
      type: String,
      required: true
    },

    title: {
      type: String,
      default: ''
    },

    files: {
      type: Array,
      required: true
    },

    matches: {
      type: Array,
      required: true
    },

    fetchState: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loadingAllDocuments: false,
      pdf: {
        open: false,
        url: '',
        name: '',
        highlight: ''
      }
    };
  },

  fetchOnServer: false,

  computed: {
    primaryDocuments () {
      return this.files.filter(x => x.isPrimary);
    },

    documents () {
      return this.files
        .filter(x => ['DOCUMENT', 'LINK'].includes(x.type) && !x.isPrimary)
        .sort((a, b) =>
          (a.fileName ?? a.filePath).localeCompare((b.fileName ?? b.filePath), 'nl', {
            numeric: true,
            ignorePunctuation: true
          })
        );
    },

    forms () {
      return this.files
        .filter(x => x.type === 'FORM' && !x.isPrimary)
        .sort((a, b) =>
          a.fileName.localeCompare(b.fileName, 'nl', {
            numeric: true,
            ignorePunctuation: true
          })
        );
    },

    publications () {
      return this.files
        .filter(x => x.type === 'PUBLICATION' && !x.isPrimary)
        .sort((a, b) =>
          a.fileName.localeCompare(b.fileName, 'nl', {
            numeric: true,
            ignorePunctuation: true
          })
        );
    }
  },

  watch: {

  },

  methods: {
    openPdf ({ url, match, name }) {
      this.pdf.url = url;
      this.pdf.name = name;
      this.pdf.highlight = match;
      this.pdf.open = true;
    },

    async downloadAll () {
      this.loadingAllDocuments = true;

      const response = await this.$axios.get(
        'tenderfolder/zipped/' + this.tenderId,
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(response.data);

      const a = window.document.createElement('a');

      if (this.title) {
        a.setAttribute(
          'download',
          `${this.title.replaceAll(/\s/g, '_')}_documenten.zip`
        );
      }

      a.style.display = 'none';
      a.href = url;

      window.document.body.appendChild(a);

      a.click();

      window.URL.revokeObjectURL(url);
      a.remove();

      this.loadingAllDocuments = false;
    }
  }
};
